import {t} from "@lingui/core/macro";

import {AIActivity} from "@khan/guide-types";

import {SearchableContentKinds} from "./constants.ts";

import article from "@phosphor-icons/core/regular/article.svg";
import pencilSimple from "@phosphor-icons/core/regular/pencil-simple.svg";
import play from "@phosphor-icons/core/regular/play.svg";

export const IsArraysContentsEqual = (a: string[], b: string[]) => {
    if (a.length !== b.length) {
        return false;
    }
    return a.every((el) => b.includes(el));
};

export const getContentIcon = (
    contentKind: string | undefined | null,
): PhosphorRegular => {
    switch (contentKind) {
        case SearchableContentKinds.Article:
            return article;
        case SearchableContentKinds.Video:
            return play;
        case SearchableContentKinds.Exercise:
            return pencilSimple;
        default:
            return pencilSimple;
    }
};

export const getTranslatedContentType = (
    contentKind: string | undefined | null,
): string => {
    switch (contentKind) {
        case SearchableContentKinds.Article:
            return t`Article`;
        case SearchableContentKinds.Video:
            return t`Video`;
        case SearchableContentKinds.Exercise:
            return t`Exercise`;
        case SearchableContentKinds.Topic:
            return t`Topic`;
        case SearchableContentKinds.Course:
            return t`Course`;
        case SearchableContentKinds.Unit:
            return t`Unit`;
        case SearchableContentKinds.Lesson:
            return t`Lesson`;
        case "CurationPage":
            return t`Curation Page`;
        case SearchableContentKinds.AIActivity:
            return t`AI Activity`;
        default:
            return contentKind || "";
    }
};

export const isActivitySearchable = (slug: string): boolean => {
    return ![
        AIActivity.DefaultLearner,
        AIActivity.DefaultTeacher,
        AIActivity.DefaultParent,
    ].includes(slug as AIActivity);
};
